import { render, staticRenderFns } from "./Beds.vue?vue&type=template&id=e41c16fc&scoped=true&"
import script from "./Beds.vue?vue&type=script&lang=js&"
export * from "./Beds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41c16fc",
  null
  
)

export default component.exports